import { PromoteStudentSchoolEnrollmentModalComponent } from './../promote-student-school-enrollment-modal/promote-student-school-enrollment-modal.component';
import { Component, computed, effect, OnInit, QueryList, signal, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { firstValueFrom, timer } from 'rxjs';
import { filter, switchMap, take, tap, timeout } from 'rxjs/operators';
import { County } from 'src/app/model/county';
import { Region } from 'src/app/model/region.model';
import { School, Grade } from 'src/app/model/school.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { PagingService } from 'src/app/service/paging.service';
import { EnrollmentReportStudent, EnrollmentReportResult } from '../../child-reports/enrollment-report/model/enrollment-report-result.model';
import { EnrollmentReportService } from '../../child-reports/enrollment-report/service/enrollment-report.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { AgePipe } from 'src/app/pipes/age.pipe';
import { DeleteGroupChildEnrollmentModalComponent } from '../edit-child/edit-child-enrollment/delete-group-child-enrollment-modal/delete-group-child-enrollment-modal.component';
import { EditGroupChildEnrollmentModalComponent } from '../edit-child/edit-child-enrollment/edit-group-child-enrollment-modal/edit-group-child-enrollment-modal.component';
import { EditChildEnrollmentModalComponent } from '../edit-child/edit-child-enrollment/edit-child-enrollment-modal/edit-child-enrollment-modal.component';
import { AccessService } from '../../navigation/service/access.service';
import { GraduateStudentSchoolEnrollmentModalComponent } from '../edit-child/graduate-student-school-enrollment-modal/graduate-student-school-enrollment-modal.component';
import { StudentTerminationsService } from '../service/student-terminations.service';
import { Route, SearchCriteria, SearchResult, TrackingType } from 'src/app/model/session-tracking/tracking-type';
import { DatePipe } from '@angular/common';
import { HelperService } from 'src/app/service/helper.service';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { RegionDropdownTwoWayComponent } from '../../common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { CountyDropdownTwoWayComponent } from '../../common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';
import { CountyEntityService } from '../../common-components/service/county-entity.service';
import { DistrictEntityService } from '../../common-components/service/district-entity.service';
import { DistrictDropdownTwoWayComponent } from '../../common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';
import { SchoolDropdownTwoWayComponent } from '../../common-components/school/school-dropdown-two-way/school-dropdown-two-way.component';
import { SchoolYearComponent } from '../../common-components/school-year/school-year.component';
import { SearchChildrenComponent } from '../search-children/search-children.component';
import { Router } from '@angular/router';
import { createDelayedLoadingSignal } from 'src/app/util/create-delayed-loading-signal';
import { AuthEffects } from '../../auth/state/auth.effects';

@Component({
    selector: 'search-group-school-enrollments',
    templateUrl: './search-group-school-enrollments.component.html',
    styleUrls: ['./search-group-school-enrollments.component.scss']
})
export class SearchGroupSchoolEnrollmentsComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode: RegionDropdownTwoWayComponent;
    @ViewChild('appCountyCode') appCountyCode: CountyDropdownTwoWayComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode: DistrictDropdownTwoWayComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode: SchoolDropdownTwoWayComponent;
    @ViewChild('appSchoolYear') appSchoolYear: SchoolYearComponent;
    @ViewChild('tab2Search') tab2Search: SearchChildrenComponent;
    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    // selectRegionIds: number[] = []; // no longer in use
    selectCountyIds: number[] = [];
    selectSchoolDistrictIds: number[] = [];
    selectSchoolIds: number[] = [];
    selectSchoolYear: string;

    rAttending: boolean = false;
    rNotAttending: boolean = false;

    expiredEligibility: boolean = true;
    expiredQAD: boolean = false;
    notWithdrawnFromSchool: boolean = false;
    k12Ungraded: boolean = false;
    verifiedCoes: boolean = false;

    chosenGrades: Grade[] = [];
    chosenGrade: Grade;

    // Component variables
    resetField: boolean = false;
    selectedTabIndex: number = 0;

    // Table display
    columns = {
        EDIT: { INDEX: 1, ENABLED: true, SORT: 'EDIT', DATA: 'EDIT', DISABLED: false },

        School: { INDEX: 3, ENABLED: true, SORT: 'SCHOOL.NAME', DATA: 'SCHOOL.NAME', DISABLED: false },

        'MSD Number': { INDEX: 6, ENABLED: true, SORT: 'MSD_NUMBER', DATA: 'MSD_NUMBER', DISABLED: true },
        SSID: { INDEX: 7, ENABLED: true, SORT: 'SSID', DATA: 'SSID', DISABLED: true },

        Name: { INDEX: 10, ENABLED: true, SORT: 'PERSON.LAST_NAME', DATA: 'PERSON.LAST_NAME', DISABLED: true },
        DOB: { INDEX: 11, ENABLED: true, SORT: 'DOB', DATA: 'DOB', DISABLED: true },

        Gender: { INDEX: 13, ENABLED: true, SORT: 'SEX', DATA: 'SEX', DISABLED: true },

        Grade: { INDEX: 20, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE', DATA: 'GRADE', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },
        QAD: {
            INDEX: 21,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        EoE: {
            INDEX: 22,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        'Enroll Date': {
            INDEX: 27,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE',
            DATA: 'ENROLLMENT_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Withdrawal Date': {
            INDEX: 28,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE',
            DATA: 'WITHDRAWAL_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Departure Date': {
            INDEX: 29,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].DEPARTURE_DATE',
            DATA: 'DEPARTURE_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        Track: { INDEX: 30, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].TRACK', DATA: 'TRACK', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },
        'Enroll Type': {
            INDEX: 31,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE',
            DATA: 'ENROLLMENT_TYPE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        }
    };
    selectedColumns: string[] = [];

    baseDisplayedColumns: string[] = [];
    suffixColumns: string[] = [];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSources: MatTableDataSource<EnrollmentReportStudent>[] = [];
    shoppingCartTableDataSources: MatTableDataSource<EnrollmentReportStudent>[] = [];

    // Results
    results: EnrollmentReportResult[] = [];
    filter: string = '';
    studentLength: number;

    // Shopping Cart
    shoppingCartBackup: any = {};
    shoppingCart: any[] = [];
    shoppingCartFilter: string = '';
    shoppingCartLength: number;

    // Search Children Shopping Cart
    searchChildrenShoppingCart: any[] = [];
    searchChildrenShoppingCartInput: any[] = [];

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();
    getAgePipe = new AgePipe();

    // Permissions
    featuresCheck: string[] = [
        'Promote Group School Enrollments',
        'Graduate Group School Enrollments',
        'Edit Student School Enrollments',
        'Create Student School Enrollments',
        'Delete Student School Enrollments'
    ];
    featurePermissions: any;
    promises: Array<any> = [];
    loaddistrict: boolean = true;

    localStorageReset: any;

    regionLoading = signal(false);
    countyLoading = signal(false);
    districtLoading = signal(false);
    schoolLoading = signal(false);

    backupLoading = signal(false);

    // Immediate combined state
    rawLoading = computed(() => this.backupLoading());
    allLocationLoading = computed(() => this.regionLoading() || this.countyLoading() || this.districtLoading() || this.schoolLoading());

    // UI spinner state
    isBackupLoading = createDelayedLoadingSignal(this.rawLoading, 2000);

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private enrollmentReportService: EnrollmentReportService,
        private studentTerminationsService: StudentTerminationsService,
        public accessService: AccessService,
        private datePipe: DatePipe,
        private helperService: HelperService,
        private countyService: CountyEntityService,
        private authEffects: AuthEffects,
        private router: Router
    ) {
        effect(
            () => {
                const anyLoading = this.allLocationLoading();

                // only turn it off when everything finished
                if (!anyLoading && this.backupLoading()) {
                    this.backupLoading.set(false);
                }
            },
            { allowSignalWrites: true }
        );
    }

    ngOnInit(): void {
        this.isLoading = true;
        // Permissions
        this.getFeaturePermissions();

        // Get localStorageReset
        try {
            this.localStorageReset = JSON.parse(localStorage.getItem('reset') || '{}');
        } catch (e) {
            this.localStorageReset = {};
        }

        this.getBackup();

        // Display columns
        let prefixColumns: string[] = [];
        this.displayedColumns = this.generateDisplayColumns(prefixColumns);

        if (!this.localStorageReset[this.router.url]) {
            Promise.all(this.promises).then((res) => {
                setTimeout(() => {
                    if (!!this.shoppingCartBackup.SearchResults) {
                        this.backupLoading.set(true);
                        setTimeout(() => {
                            this.restoreSearchCriteriaFromBackup();
                        }, 200);
                    }
                }, 1000);
                this.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    }

    getFeaturePermissions() {
        this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
            this.featurePermissions = res;
        });
    }

    search() {
        if (this.checkValid() && (this.rAttending || this.rNotAttending)) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.enrollmentReportService.searchStudentsBySchool(this.generatePayload()).subscribe({
                next: (res) => {
                    if (res.students) {
                        this.shoppingCartRemoveAll(false);

                        res.students.forEach((student: any) => {
                            // Attach AGE
                            student.AGE = parseInt(this.getAgePipe.transform(student.DOB).replace(/[{()}]/g, ''));
                        });

                        this.results = res.students.sort((n1: EnrollmentReportResult, n2: EnrollmentReportResult) => (n1.NAME! > n2.NAME! ? 1 : -1));
                        this.studentLength = res.students.length;
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Enrollment Report.' };
                    }
                },
                error: (err) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving Enrollment Report.' };
                },
                complete: () => {
                    this.finalizeSearch(this.results.length);
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please select a School District and an Enrollment Type.' };
        }
    }

    finalizeSearch(resLen: number) {
        // Display current performance period
        this.currentSchoolYear = this.selectedSchoolYear;
        // Updates the Tables to be displayed w/ this.results
        if (resLen > 0) {
            this.updateDataSource(true);
            this.updateShoppingCartDataSource();

            // Save shopping cart
            this.restoreShoppingCart();

            // Now we can save the combined new backup
            this.saveBackup();
        }
        // Display results
        this.isLoading = false;
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
        payload.schoolYear = this.selectedSchoolYear;

        payload.rAttending = this.rAttending;
        payload.rNotAttending = this.rNotAttending;

        payload.expiredEligibility = this.expiredEligibility;
        payload.expiredQAD = this.expiredQAD;
        payload.notWithdrawnFromSchool = this.notWithdrawnFromSchool;

        payload.chosenGrade = this.chosenGrade;

        if (this.shoppingCartBackup.SearchResults && this.shoppingCartBackup.SearchResults.length > 0) {
            payload.studentIDs = this.shoppingCartBackup.SearchResults.map((s: any) => s.ID);
        }

        return payload;
    }

    generateDisplayColumns(prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    updateDataSource(newSort?: boolean) {
        setTimeout(() => {
            this.tableDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.results.filter((r) => !this.shoppingCart.map((sc) => sc.ID).includes(r.ID));
            //console.warn(dataSource.data);

            // Paginator
            dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            if (newSort) {
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
            } else {
                dataSource.sort.sortChange.emit(this.sorts.toArray()[0]);
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSources.push(dataSource);
        }, 100);
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.chosenSchoolDistricts.length > 0 && this.selectedSchoolYear && (this.rAttending || this.rNotAttending)) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedSchoolYear = performancePeriod;
    }

    // Filter Emiiters
    gradeEventEmitter(grades: Grade[]) {
        if (grades) {
            if (Array.isArray(grades)) {
                this.chosenGrades = grades;
                this.chosenGrade = grades[0];
            } else {
                this.chosenGrades = [grades];
                this.chosenGrade = grades;
            }
        }
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To reset the value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.rAttending = false;
        this.rNotAttending = false;
        this.expiredEligibility = true;
        this.expiredQAD = false;
        this.notWithdrawnFromSchool = false;
        this.k12Ungraded = false;
        this.verifiedCoes = false;

        this.msg = {};

        this.deSelectAllColumns(this.columns);

        this.localStorageReset[this.router.url] = true;
        localStorage.setItem('reset', JSON.stringify(this.localStorageReset));
    }

    announceSortChange(sortState: Sort) {}

    checkbox(properties: string[], obj: any) {
        let columns: any = obj;
        let columnKeys = Object.keys(columns);

        columnKeys = columnKeys.filter((key) => !obj[key].DISABLED);

        columnKeys.forEach((filter: string) => {
            if (properties.indexOf(filter) >= 0) {
                columns[filter].ENABLED = true;
            } else {
                columns[filter].ENABLED = false;
            }
        });
    }

    selectAllColumns(obj: any) {
        let columnKeys = Object.keys(obj);

        columnKeys = columnKeys.filter((key) => !obj[key].DISABLED);

        this.checkbox(columnKeys, obj);

        this.selectedColumns = columnKeys;
    }

    deSelectAllColumns(obj: any) {
        this.checkbox([], obj);

        this.selectedColumns = [];
    }

    selectionCount(obj: any, key: string) {
        let count: number = 0;

        if (obj[key]) {
            if (obj[key].OPTIONS) {
                obj[key].OPTIONS.forEach((option: any) => {
                    if (option.ENABLED) {
                        count += 1;
                    }
                });
            }
        }

        return count;
    }

    searchStudentChange(students: any[]) {
        this.results = students;

        // Updates the Tables to be displayed w/ this.results
        if (this.results.length > 0) {
            this.updateDataSource();
        }
    }

    addChild(child: any) {}

    // Modals
    addDialog(students?: EnrollmentReportStudent[]) {
        let payload: any = {};
        payload.students = students;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(EditChildEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {});
    }

    editDialog(students?: EnrollmentReportStudent[]) {
        let payload: any = {};
        payload.students = students ? students : this.results;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(EditGroupChildEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {});
    }

    deleteDialog(students?: EnrollmentReportStudent[]) {
        let payload: any = {};
        payload.students = students;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(DeleteGroupChildEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res && res.deleted) {
                this.results = this.results.filter((r) => !this.shoppingCart.map((sc) => sc.ID).includes(r.ID));
                this.studentLength = this.results.length;
                this.shoppingCart = [];

                this.updateDataSource();
                this.updateShoppingCartDataSource();

                this.saveBackup();
            }
        });
    }

    promoteDialog(students?: EnrollmentReportStudent[]) {
        let payload: any = {};
        payload.students = students ? students : this.results;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(PromoteStudentSchoolEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {});
    }

    graduateDialog(students?: EnrollmentReportStudent[]) {
        let payload: any = {};
        payload.students = students ? students : this.results;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(GraduateStudentSchoolEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res && res.refresh) {
                this.getGroupCurrentStudentTerminationStatuses(students);
            }
        });
    }

    getGroupCurrentStudentTerminationStatuses(students?: any[]) {
        this.studentTerminationsService.getGroupCurrentStudentTerminationStatuses(students).subscribe((res) => {
            if (res.students) {
                this.results = this.mergeArrays(this.results, JSON.parse(res.students), ['ID', 'STUDENT_TERMINATION_STATUSES']);
                this.shoppingCart = this.mergeArrays(this.shoppingCart, JSON.parse(res.students), ['ID', 'STUDENT_TERMINATION_STATUSES']);

                this.updateDataSource();
                this.updateShoppingCartDataSource();
            } else if (res?.msg) {
            } else {
            }
        });
    }

    mergeArrays(targetArray: any[], mergingArray: any[], propertiesToMerge: string[]) {
        if (propertiesToMerge) {
            mergingArray.forEach((obj) => {
                for (let propertyName in obj) {
                    if (
                        !propertiesToMerge.find((property) => {
                            return property === propertyName;
                        })
                    ) {
                        delete obj[propertyName];
                    }
                }
            });
        }

        let result: any[] = targetArray.map((obj) => {
            return Object.assign(
                obj,
                mergingArray.find((ma) => ma.ID === obj.ID)
            );
        });

        return result;
    }

    // Shopping Cart functions
    shoppingCartAdd(obj: any) {
        this.shoppingCart.push(obj);

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    shoppingCartAddAll() {
        this.results.forEach((obj) => {
            let shoppingCartIndex = this.shoppingCart.findIndex((sc) => sc.ID === obj.ID);

            if (shoppingCartIndex === -1) {
                this.shoppingCart.push(obj);
            }
        });

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    shoppingCartRemove(obj: any) {
        let shoppingCartIndex = this.shoppingCart.findIndex((sc) => sc.ID === obj.ID);

        if (shoppingCartIndex >= 0) {
            this.shoppingCart.splice(shoppingCartIndex, 1);
        }

        // Search Children removal
        if (!obj.SCHOOL) {
            let searchChildrenShoppingCartIndex = this.searchChildrenShoppingCart.findIndex((sc) => sc.ID === obj.ID);

            if (searchChildrenShoppingCartIndex >= 0) {
                this.searchChildrenShoppingCart.splice(searchChildrenShoppingCartIndex, 1);

                this.searchChildrenShoppingCartInput = JSON.parse(JSON.stringify(this.searchChildrenShoppingCart));
            }
        }

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    shoppingCartRemoveAll(saveBackup: boolean = true) {
        this.shoppingCart = [];
        this.searchChildrenShoppingCart = [];
        this.searchChildrenShoppingCartInput = [];

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        if (saveBackup) {
            this.saveBackup();
        }
    }

    updateShoppingCartDataSource() {
        setTimeout(() => {
            this.shoppingCartTableDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            //dataSource.data = this.shoppingCart;
            dataSource.data = [...new Set([...this.shoppingCart, ...this.searchChildrenShoppingCart])];

            // Paginator
            dataSource.paginator = this.paginators.toArray()[1];

            // Sort
            dataSource.sort = this.sorts.toArray()[1];
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            if (this.shoppingCart.length === 0) {
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
            } else {
                dataSource.sort.sortChange.emit(this.sorts.toArray()[1]);
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.shoppingCartTableDataSources.push(dataSource);
            this.shoppingCartLength = dataSource.data.length;
        }, 100);
    }

    setShoppingCartFilter() {
        this.shoppingCartTableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.shoppingCartFilter.trim().toLocaleLowerCase();
        });
    }

    // Backup functions
    getBackup() {
        let deferred = new Promise((resolve, reject) => {
            this.authEffects.isLoggedInNavigated$
                .pipe(
                    filter(Boolean), // only proceed when true
                    take(1), // run once per component lifecycle (or remove if you want per-login)
                    switchMap(() => this.helperService.currSessionTracking$.pipe(take(1)))
                )
                .subscribe((curSessionTrack) => {
                    let searchRoute = curSessionTrack.routes
                        ?.slice()
                        .reverse()
                        .find((x) => x.path == this.router.url && x.searchCriterias.length > 0);

                    if (searchRoute != null) {
                        let workingShoppingCart: any = {
                            SearchCriterias: {},
                            SearchResults: [],
                            ChosenResults: []
                        };

                        workingShoppingCart.SearchCriterias = ['firstTab', 'secondTab']
                            .map((screen) =>
                                curSessionTrack.routes
                                    ?.slice()
                                    .reverse()
                                    .flatMap((route) => route.searchCriterias ?? [])
                                    .find((sc) => sc.screenName === screen)
                            )
                            .filter((item): item is NonNullable<typeof item> => Boolean(item));

                        workingShoppingCart.SearchResults = searchRoute.searchResults;
                        workingShoppingCart.ChosenResults = searchRoute.chosenResults;

                        this.shoppingCartBackup = workingShoppingCart;
                    }

                    resolve(true);
                });
        });
        this.promises.push(deferred);
    }

    async restoreSearchCriteriaFromBackup() {
        // firstTab
        let searchCriteriaTab1 = this.shoppingCartBackup?.SearchCriterias.find((sc: SearchCriteria) => sc.screenName === 'firstTab');
        if (searchCriteriaTab1?.payLoad) {
            let payloadTab1 = JSON.parse(searchCriteriaTab1?.payLoad);
            //console.warn(payloadTab1);
            let searchResultsTab1 = searchCriteriaTab1?.results;
            //console.warn(searchResultsTab1);
            let chosenResultsTab1 = searchCriteriaTab1?.results;
            //console.warn(chosenResultsTab1);

            this.chosenRegions = payloadTab1?.chosenRegions?.map((id: number) => ({ ID: id })) ?? [];

            setTimeout(() => {
                this.chosenCounties = payloadTab1?.chosenCounties?.map((id: number) => ({ ID: id })) ?? [];
                setTimeout(() => {
                    this.chosenSchoolDistricts = payloadTab1?.chosenSchoolDistricts?.map((id: number) => ({ ID: id })) ?? [];
                    setTimeout(() => {
                        this.chosenSchools = payloadTab1?.chosenSchools?.map((id: number) => ({ ID: id })) ?? [];

                        this.saveBackup();
                    }, 3);
                }, 2);
            }, 1);

            if (payloadTab1?.schoolYear) {
                this.selectSchoolYear = payloadTab1.schoolYear;
            }

            this.rAttending = !!payloadTab1.rAttending;
            this.rNotAttending = !!payloadTab1.rNotAttending;
            this.expiredEligibility = !!payloadTab1.expiredEligibility;
            this.expiredQAD = !!payloadTab1.expiredQAD;
            this.notWithdrawnFromSchool = !!payloadTab1.notWithdrawnFromSchool;

            if (payloadTab1?.chosenGrade) {
                this.chosenGrades = [payloadTab1.chosenGrade];
            }
        }

        // secondTab
        /*
        let searchCriteriaTab2 = this.shoppingCartBackup?.SearchCriterias.find((sc: SearchCriteria) => sc.screenName === 'secondTab');
        if (searchCriteriaTab2?.payLoad) {
            if (!searchCriteriaTab1?.payLoad) {
                this.selectedTabIndex = 1;
            }

            let payloadTab2 = JSON.parse(searchCriteriaTab2.payLoad);
            //console.warn(payloadTab2);
            let searchResultsTab2 = searchCriteriaTab2.results;
            //console.warn(searchResultsTab2);
            let chosenResultsTab2 = searchCriteriaTab2.results;
            //console.warn(chosenResultsTab2);

            const patch: any = {};
            if (payloadTab2?.studentFirstName) {
                patch.firstName = payloadTab2?.studentFirstName;
            }
            if (payloadTab2?.studentMiddleInitial) {
                patch.middleName = payloadTab2?.studentMiddleInitial;
            }
            if (payloadTab2?.studentLastName) {
                patch.lastName = payloadTab2?.studentLastName;
            }
            if (payloadTab2?.studentSecondLastName) {
                patch.secondLastName = payloadTab2?.studentSecondLastName;
            }
            if (payloadTab2?.studentCity) {
                patch.birthCity = payloadTab2?.studentCity;
            }
            if (payloadTab2?.startDOBDate) {
                patch.startDate = payloadTab2?.startDOBDate;
            }
            if (payloadTab2?.endDOBDate) {
                patch.endDate = payloadTab2?.endDOBDate;
            }
            if (payloadTab2?.studentMsdNumber) {
                patch.msd = payloadTab2?.studentMsdNumber;
            }
            if (payloadTab2?.studentMsdNumber) {
                patch.msd = payloadTab2?.studentMsdNumber;
            }
            if (payloadTab2?.coeNumber) {
                patch.coe = payloadTab2.coeNumber;
            }
            if (payloadTab2?.studentSSID) {
                patch.ssid = payloadTab2?.studentSSID;
            }
            if (payloadTab2?.studentSISID) {
                patch.localSISID = payloadTab2?.studentSISID;
            }
            if (payloadTab2?.studentMSIX) {
                patch.msix = payloadTab2?.studentMSIX;
            }
            if (payloadTab2?.legalMotherFirstName) {
                patch.motherFirstName = payloadTab2?.legalMotherFirstName;
            }
            if (payloadTab2?.legalMotherLastName) {
                patch.motherLastName = payloadTab2?.legalMotherLastName;
            }
            if (payloadTab2?.legalFatherFirstName) {
                patch.fatherFirstName = payloadTab2?.legalFatherFirstName;
            }
            if (payloadTab2?.legalFatherLastName) {
                patch.fatherLastName = payloadTab2?.legalFatherLastName;
            }
            if (payloadTab2?.studentState) {
                patch.birthState = payloadTab2?.studentState;
            }
            if (payloadTab2?.studentCountry) {
                patch.birthCountry = payloadTab2?.studentCountry;
            }
            if (payloadTab2?.studentSex) {
                patch.gender = payloadTab2?.studentSex;
            }
            if (payloadTab2?.terminationFlag) {
                patch.includeHardTerminations = payloadTab2?.terminationFlag;
            }
            if (payloadTab2?.chosenRegions) {
                this.tab2Search.chosenRegions = payloadTab2?.chosenRegions?.map((id: number) => ({ ID: id })) ?? [];
            }

            setTimeout(() => {
                this.tab2Search.chosenCounties = payloadTab2?.chosenCounties?.map((id: number) => ({ ID: id })) ?? [];
                setTimeout(() => {
                    this.tab2Search.chosenSchoolDistricts = payloadTab2?.chosenSchoolDistricts?.map((id: number) => ({ ID: id })) ?? [];
                    setTimeout(() => {
                        this.tab2Search.chosenSchools = payloadTab2?.chosenSchools?.map((id: number) => ({ ID: id })) ?? [];
                    }, 1500);
                }, 1000);
            }, 500);

            if (Object.keys(patch).length > 0) {
                this.tab2Search.searchStudentForm.patchValue(patch);
            }

            // Expand panels if needed
            if (payloadTab2?.chosenCounties?.length > 0 || payloadTab2?.chosenSchoolDistricts?.length > 0 || payloadTab2?.chosenSchools?.length > 0) {
                this.tab2Search.locationExpanded = true;
            }

            if (
                payloadTab2?.legalMotherFirstName ||
                payloadTab2?.legalMotherLastName ||
                payloadTab2?.legalFatherFirstName ||
                payloadTab2?.legalFatherLastName
            ) {
                this.tab2Search.familyExpanded = true;
            }

            if (payloadTab2?.studentState || payloadTab2?.studentCountry || payloadTab2?.studentSex) {
                this.tab2Search.personalExpanded = true;
            }
        }
		*/
    }

    restoreShoppingCart() {
        if (this.shoppingCartBackup.ChosenResults && this.shoppingCartBackup.ChosenResults.length > 0) {
            this.shoppingCart = [];
            //let chosenResults = this.shoppingCartBackup.ChosenResults.map((cr: any) => cr.ID);
            let chosenResults = this.shoppingCartBackup.ChosenResults;
            this.shoppingCart = this.results.filter((r) => chosenResults.includes(r.ID));

            this.updateDataSource();
            this.updateShoppingCartDataSource();

            this.shoppingCartBackup.ChosenResults = [];
        }
    }

    async saveBackup() {
        let shoppingCartBackup: any = {};
        shoppingCartBackup.CartId = 'GroupEnrollments';

        shoppingCartBackup.SearchCriterias = await this.generateSearchCriteriasFirstTabOnlyBackup();
        shoppingCartBackup.SearchResults = this.generateResultsBackup(this.results);
        shoppingCartBackup.ChosenResults = this.generateChosenResultsBackup(this.shoppingCart);

        const route = {} as Route;
        route.path = this.router.url;

        route.timeStamp = new Date().toLocaleString();
        route.bLastVisited = false;
        route.searchCriterias = [];
        route.searchResults = [];
        route.chosenResults = [];

        // FIRST TAB ONLY
        const searchResult = {} as SearchResult;
        searchResult.screenName = 'firstTab';
        searchResult.results = shoppingCartBackup.SearchResults;
        route.searchResults.push(searchResult);

        const chosenResult = {} as SearchResult;
        chosenResult.screenName = 'firstTab';
        chosenResult.results = shoppingCartBackup.ChosenResults;
        route.chosenResults.push(chosenResult);

        const searchCriteria = {} as SearchCriteria;
        searchCriteria.screenName = 'firstTab';
        searchCriteria.payLoad = JSON.stringify(shoppingCartBackup.SearchCriterias.payLoad);
        route.searchCriterias.push(searchCriteria);

        this.helperService.addCurrSessionTrackingRoute(route);

        this.localStorageReset[this.router.url] = false;
        localStorage.setItem('reset', JSON.stringify(this.localStorageReset));
    }

    async generateSearchCriteriasFirstTabOnlyBackup() {
        let prevTrackingType: TrackingType;
        const trackingType = await firstValueFrom(this.helperService.currSessionTracking$);
        if (!trackingType) {
            return { payLoad: {} };
        }

        // start with payload from search-children if it exists (safe optional chaining)
        const searchCriterias: any = { payLoad: {} };

        const existingPayLoad = trackingType.routes?.[0]?.searchCriterias?.[0]?.payLoad;

        if (existingPayLoad && typeof existingPayLoad === 'object' && !Array.isArray(existingPayLoad)) {
            // clone so we don’t mutate the original object reference
            searchCriterias.payLoad = { ...(existingPayLoad as Record<string, any>) };
        } else {
            searchCriterias.payLoad = {};
        }

        // now overlay first-tab fields
        searchCriterias.payLoad.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        searchCriterias.payLoad.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        searchCriterias.payLoad.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        searchCriterias.payLoad.chosenSchools = this.chosenSchools.map((obj) => obj.ID);

        searchCriterias.payLoad.schoolYear = this.selectedSchoolYear;

        searchCriterias.payLoad.rAttending = this.rAttending;
        searchCriterias.payLoad.rNotAttending = this.rNotAttending;

        searchCriterias.payLoad.expiredEligibility = this.expiredEligibility;
        searchCriterias.payLoad.expiredQAD = this.expiredQAD;
        searchCriterias.payLoad.notWithdrawnFromSchool = this.notWithdrawnFromSchool;

        if (this.chosenGrade) {
            searchCriterias.payLoad.chosenGrade = { ID: this.chosenGrade.ID };
        } else {
            delete searchCriterias.payLoad.chosenGrade;
        }

        return searchCriterias;
    }

    generateResultsBackup(results: any[]) {
        return results.map((r) => {
            return { ID: r.ID };
        });
    }

    generateChosenResultsBackup(shoppingCart: any[]) {
        return shoppingCart.map((sc) => {
            return { ID: sc.ID };
        });
    }

    searchChildrenShoppingCartEvent(event: any) {
        this.searchChildrenShoppingCart = event;

        this.updateShoppingCartDataSource();
    }
}
